export default __webpack_public_path__ + "static/media/tool_item_2.f22ee45c.png";